import _classCallCheck from "/mnt/ramdisk/app/solvuu-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/ramdisk/app/solvuu-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/ramdisk/app/solvuu-ui/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/ramdisk/app/solvuu-ui/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/ramdisk/app/solvuu-ui/node_modules/@babel/runtime/helpers/esm/inherits";
import BaseView from './base';

var MatrixRowView =
/*#__PURE__*/
function (_BaseView) {
  _inherits(MatrixRowView, _BaseView);

  function MatrixRowView(matrix, row) {
    var _this;

    _classCallCheck(this, MatrixRowView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MatrixRowView).call(this, matrix, 1, matrix.columns));
    _this.row = row;
    return _this;
  }

  _createClass(MatrixRowView, [{
    key: "set",
    value: function set(rowIndex, columnIndex, value) {
      this.matrix.set(this.row, columnIndex, value);
      return this;
    }
  }, {
    key: "get",
    value: function get(rowIndex, columnIndex) {
      return this.matrix.get(this.row, columnIndex);
    }
  }]);

  return MatrixRowView;
}(BaseView);

export { MatrixRowView as default };